<template>
  <div id="Admin" style="height:100%">
    <el-container style="background-color:white;">
      <el-header>
        <div>
          <span>VIP升级-管理后台</span>
        </div>
        <div class="exit" @click="exit()">
          <i class="el-icon-s-unfold"></i>
          <span>退出</span>
        </div>
      </el-header>
      <el-main>
        <el-tabs v-model="biaoshi" @tab-click="handleClick">
          <el-tab-pane v-for="(item,key) in biaoshiArr" :key=key :label="item.biaoshi+'各前端'" :name="item.biaoshi">
          </el-tab-pane>
        </el-tabs>
        <div style="margin-top:20px;">
          <p style="color:#ccc;margin-bottom:10px;">*会员账号=等级=投注金额=有效投注*</p>
          <el-input type="textarea" rows="10" placeholder="abc=v0=100=200
qwe=v1=300=200" v-model="textarea">
          </el-input>
          <div style="margin-top:10px;">
            <el-button type="primary" @click="SetDengjiData()" size="small">更新</el-button>
            <span style="margin-left:10px;">更新时间：{{updataTime}}</span>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>


</template>

<script>
  export default {
    data() {
      return {
        biaoshi: "TWY",
        textarea: "",
        updataTime: "",
        biaoshiArr: {}
      };
    },
    methods: {
      exit() {
        this.$cookies.remove("AdminToken");
        this.$router.push({
          name: 'Login',
        })
      },
      handleClick(tab, event) {
        this.GetDengjiData();
      },
      SetDengjiData() {
        let _this = this;
        var params = new URLSearchParams();
        params.append('biaoshi', this.biaoshi);
        params.append('textareaList', this.textarea.split(/[\n]/));

        this.$http({
          method: 'post',
          url: '/SetDengjiData',
          data: params
        }).then(function (result) {
          if (result.data.code == 0) {
            _this.$message({
              message: '保存成功',
              type: 'success'
            });
            _this.GetDengjiData();
          } else {
            _this.$alert(`${result.data.msg}`, {
              confirmButtonText: '确定',
            });
          }

        }).catch(function (error) {
          console.log(error);
        })
      },
      GetDengjiData() {
        let _this = this;
        var params = new URLSearchParams();
        params.append('biaoshi', this.biaoshi);

        this.$http({
          method: 'post',
          url: '/GetDengjiData',
          data: params
        }).then(function (result) {
          if (result.data.code == 0) {
            _this.textarea = "";
            let t = "";
            for (let d = 0; d < result.data.data.textarea.length; d++) {
              t += result.data.data.textarea[d].userName + "=";
              t += result.data.data.textarea[d].dengji + "=";
              t += result.data.data.textarea[d].touzhu + "=";
              t += result.data.data.textarea[d].youxiao;
              if (d != result.data.data.textarea.length - 1) {
                t += "\n";
              }
            }
            _this.textarea = t;
            _this.updataTime = result.data.data.updataTime;
          } else {
            _this.$alert(`${result.data.msg}`, {
              confirmButtonText: '确定',
            });
          }

        }).catch(function (error) {
          console.log(error);
        })
      },
      Getbiaoshi() {
        let _this = this;
        var params = new URLSearchParams();
        this.$http({
          method: 'post',
          url: '/Getbiaoshi',
          data: params
        }).then(function (result) {
          _this.biaoshiArr = result.data.data;
          console.log(result.data.data)

        }).catch(function (error) {
          console.log(error);
        })
      },

    },
    mounted() {
      this.GetDengjiData();
      this.Getbiaoshi();
    },
    computed: {}
  };

</script>

<style scoped>
  .el-header {
    background: #5874c8;
    color: #fff;
    margin: 0;
    display: flex;
    justify-content: space-between;
    height: 60px;
    line-height: 60px;
    padding: 0px 30px;
    align-items: center;
    color: #e1e4f6 !important;
    font-size: 16px;
    font-weight: 600;
  }

  .el-header .exit {
    cursor: pointer;
  }

  #Admin {
    background-color: #f7f7f7;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Index.vue